import { useGuideTour } from "../contexts/GuideTourContext";
import styles from "./HelpQ.module.css";

/**
 * Small circular "?" button that opens the guide tour at a specific step.
 * stepIndex matches the position in GUIDE_TOUR_STEPS inside AppShell.
 */
const HelpQ = ({ stepIndex, title }) => {
  const { openAtStep } = useGuideTour();

  return (
    <span
      role="button"
      tabIndex={0}
      className={styles.helpQ}
      onClick={(e) => {
        e.stopPropagation();
        openAtStep(stepIndex);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.stopPropagation();
          openAtStep(stepIndex);
        }
      }}
      aria-label={title || "Learn more"}
      title={title || "Learn more"}
    >
      ?
    </span>
  );
};

export default HelpQ;
